import React, { useEffect } from "react";
import "./Cart_Products_card.css";
import { Table } from "react-bootstrap";
import Increment_decrement_btn_holder from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons";
import { Link, useNavigate } from "react-router-dom";
import Increment_decrement_btn_holder_add from "../../common-components/common_btn/increment_decrement_btn_holder/Increment_decrement_btn_holder_add";
import { deleteAllCart, getAllCart } from "../../../features/cart/cartSlice";
import { useDispatch, useSelector } from "react-redux";
import { encodeId } from "../../../utils/common";

function Cart_Products_card({ data, instock, setInstock }) {
  const isSignin = useSelector((state) => state.auth.is_signin);
  const dispatch = useDispatch();
  const deleteCart = async (id, product_id, varient_id) => {
    const res = await dispatch(
      deleteAllCart({ id, isSignin, product_id, varient_id })
    );
    if (res.meta?.requestStatus === "fulfilled") {
      await dispatch(getAllCart(isSignin));
    } else if (res.meta?.requestStatus === "rejected") {
      console.log("Error:", res.payload || "Not In Cart");
    }
  };
  const navigate = useNavigate();
  useEffect(() => {
  if (data?.data?.length > 0) {
    const anyOutOfStock = data.data.some((val) => {
      const stock = Number(val?.Product_Variant?.general_stock);
      const quantity = Number(val?.quantity);
      return stock < quantity;
    });

    setInstock(anyOutOfStock);
  }
}, [data]);
  return (
    <>
      <section className="Cart_Products_card">
        <div className="container">
          <div className="ContinueShopping_text">
            <Link to={"/shops"}>
              <p>Continue Shopping</p>
            </Link>
          </div>
          <div className="desktop_viw_table_holder">
            <div className="table-responsive">
              <Table>
                <thead>
                  <tr>
                    <th>Product</th>
                    <th className="text-center">Quantity</th>
                    <th className="text-end">
                      <b>Total</b>
                    </th>
                  </tr>
                </thead>
                <tbody>
                  {data?.data?.length > 0 ? (
                    data.data.map((val) => {
                      const stock = Number(val?.Product_Variant?.general_stock);
                      const quantity = Number(val?.quantity);
                      const isOutOfStock = stock < quantity;
                      // setInstock(isOutOfStock);

                      return (
                        <tr
                          key={val.id ?? `${val.product_id}-${val.variant_id}`}
                        
                        >
                          <td>
                            <div className="row">
                              <div className="col-md-4 col-12"   onClick={() =>
                            navigate(
                              `/product-details/${encodeId(val.product_id)}`
                            )
                          }
                          style={{ cursor: "pointer" }}>
                                <div className="img_holder">
                                  <img
                                    className="Product_img"
                                    src={`${process.env.REACT_APP_IMG_URL}${val.Product?.image}`}
                                    alt={val.Product?.name || "Product image"}
                                  />
                                </div>
                              </div>
                              <div className="col-md-8 col-12">
                                <div className="info_text_holder">
                                  <div>
                                    <h4>{val.Product?.name}</h4>
                                    <p className="price_text">
                                        <span>₹{val.Product_Variant?.mrp}</span>
                                       ₹{val.Product_Variant?.price}{" "}
                                    
                                    </p>
                                    <h6>
                                      Size:{" "} 
                                      <span>{val.Product_Variant?.name}</span>
                                    </h6>
                                    {isOutOfStock && (
                                      <p className="text-danger mt-2">
                                        Out of stock (Available: {stock})
                                      </p>
                                    )}
                                  </div>
                                </div>
                              </div>
                            </div>
                          </td>

                          <td>
                            <div className="Quantity_tr_holder justify-content-center">
                              <Increment_decrement_btn_holder_add
                                val={val}
                                quantity={val.quantity}
                              />
                              <FontAwesomeIcon
                                className="trash_icon"
                                icon={faTrashCan}
                                onClick={() =>
                                  deleteCart(
                                    val.id,
                                    val.product_id,
                                    val.variant_id
                                  )
                                }
                              />
                            </div>
                          </td>

                          <td>
                            <div className="price_holder">
                              <p className="price_text">
                                <span>
                                  ₹{val.Product_Variant?.mrp * val.quantity}
                                </span>
                                ₹{val.Product_Variant?.price * val.quantity}{" "}                                
                              </p>
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  )}

                  {/* {data?.data?.length > 0 ? (
                    data.data.map((val) => (
                      <tr key={val.id ?? `${val.product_id}-${val.variant_id}`}>
                        <td>
                          <div className="row">
                            <div className="col-md-4 col-12">
                              <div className="img_holder">
                                <img
                                  className="Product_img"
                                  src={`${process.env.REACT_APP_IMG_URL}${val.Product?.image}`}
                                  alt={val.Product?.name || "Product image"}
                                />
                              </div>
                            </div>
                            <div className="col-md-8 col-12">
                              <div className="info_text_holder">
                                <div>
                                  <h4>{val.Product?.name}</h4>
                                  <p>
                                    Sale Price: ₹{val.Product_Variant?.price}{" "}
                                    <span>₹{val.Product_Variant?.mrp}</span>
                                  </p>
                                  <h6>
                                    Size:{" "}
                                    <span>{val.Product_Variant?.name}</span>
                                  </h6>
                                </div>
                              </div>
                            </div>
                          </div>
                        </td>

                        <td >
                          <div className="Quantity_tr_holder justify-content-center">
                            <Increment_decrement_btn_holder_add
                              val={val}
                              quantity={val.quantity}
                            />
                            <FontAwesomeIcon
                              className="trash_icon"
                              icon={faTrashCan}
                              onClick={() =>
                                deleteCart(
                                  val.id,
                                  val.product_id,
                                  val.variant_id
                                )
                              }
                            />
                          </div>
                        </td>

                        <td>
                          <div className="price_holder">
                            <p>
                              ₹{val.Product_Variant?.price * val.quantity}{" "}
                              <span>
                                ₹{val.Product_Variant?.mrp * val.quantity}
                              </span>
                            </p>
                          </div>
                        </td>
                      </tr>
                    ))

        //               {Number(val?.Product_Variant?.general_stock) >= Number(quantity) ? (
        //                   ) : (
        //   <p className="text-danger fw-bold">Out of stock</p>
        // )}
                  ) : (
                    <tr>
                      <td colSpan={3} className="text-center">
                        No Data Available
                      </td>
                    </tr>
                  )} */}
                </tbody>
              </Table>
            </div>
          </div>

          <div className="mobile_view_table_holder">
            {data?.data?.map((val, index) => (
              <div className="mobile_product_card">
                <div className="row">
                  <div className="col-5">
                    <div className="img_holder">
                      <img
                        src={
                          process.env.REACT_APP_IMG_URL + val?.Product?.image
                        }
                        className="prod_img"
                      />
                    </div>
                  </div>
                  <div className="col-7">
                    <div className="descn_holder">
                      <p className="product_name">{val?.Product?.name}</p>
                      <p className="price_text">
                        ₹{val?.Product_Variant?.price}
                        <span className="mrp_text">
                          ₹{val?.Product_Variant?.mrp}
                        </span>
                      </p>
                      <p className="weight_text">
                        Size: <span>500gm</span>
                      </p>

                      <div className="all_btns_holder">
                        <div className="Quantity_tr_holder">
                          <Increment_decrement_btn_holder_add
                            val={val}
                            quantity={val?.quantity}
                          />
                          <FontAwesomeIcon
                            className="trash_icon"
                            icon={faTrashCan}
                            onClick={() =>
                              deleteCart(
                                val?.id,
                                val?.product_id,
                                val?.variant_id
                              )
                            }
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12"></div>
                </div>
              </div>
            ))}
          </div>

          {/* <div className="mobile_view_table_holder">
            <div className="table-responsive">
              <Table>
                <tbody>
                  <tr>
                    <th>Product</th>
                    <td>
                      <div className="row">
                        <div className="col-md-4 col-sm-4 col-6">
                          <div className="img_holder">
                            <img
                              className="Product_img"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/product/ghee.png"
                              }
                              alt={"Product_img"}
                            />
                          </div>
                        </div>
                        <div className="col-md-8 col-sm-8 col-12">
                          <div className="info_text_holder">
                            <div>
                              <h4>
                                Bilona Cow Ghee – Made from A2 Milk of Desi Cows
                              </h4>
                              <p>
                                Sale Price: ₹400 <span>₹599</span>
                              </p>
                              <h6>
                                Size: <span>1L</span>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="row">
                        <div className="col-md-4 col-sm-4 col-6">
                          <div className="img_holder">
                            <img
                              className="Product_img"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/product/ghee.png"
                              }
                              alt={"Product_img"}
                            />
                          </div>
                        </div>
                        <div className="col-md-8 col-sm-8 col-12">
                          <div className="info_text_holder">
                            <div>
                              <h4>
                                Bilona Cow Ghee – Made from A2 Milk of Desi Cows
                              </h4>
                              <p>
                                Sale Price: ₹400 <span>₹599</span>
                              </p>
                              <h6>
                                Size: <span>1L</span>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>

                    <td>
                      <div className="row">
                        <div className="col-md-4 col-sm-4 col-6">
                          <div className="img_holder">
                            <img
                              className="Product_img"
                              src={
                                process.env.PUBLIC_URL +
                                "/assets/images/product/ghee.png"
                              }
                              alt={"Product_img"}
                            />
                          </div>
                        </div>
                        <div className="col-md-8 col-sm-8 col-12">
                          <div className="info_text_holder">
                            <div>
                              <h4>
                                Bilona Cow Ghee – Made from A2 Milk of Desi Cows
                              </h4>
                              <p>
                                Sale Price: ₹400 <span>₹599</span>
                              </p>
                              <h6>
                                Size: <span>1L</span>
                              </h6>
                            </div>
                          </div>
                        </div>
                      </div>
                    </td>
                    <td></td>
                  </tr>

                  <tr>
                    <th>Quantity</th>

                    <td>
                      <div className="Quantity_tr_holder">
                        <Increment_decrement_btn_holder />{" "}
                        <FontAwesomeIcon
                          className="trash_icon"
                          icon={faTrashCan}
                        />
                      </div>
                    </td>

                    <td>
                      <div className="Quantity_tr_holder">
                        <Increment_decrement_btn_holder />{" "}
                        <FontAwesomeIcon
                          className="trash_icon"
                          icon={faTrashCan}
                        />
                      </div>
                    </td>

                    <td>
                      <div className="Quantity_tr_holder">
                        <Increment_decrement_btn_holder />{" "}
                        <FontAwesomeIcon
                          className="trash_icon"
                          icon={faTrashCan}
                        />
                      </div>
                    </td>
                    <td></td>
                  </tr>

                  <tr>
                    <th>
                      <b>Total</b>
                    </th>

                    <td>
                      <div className="price_holder">
                        <p>
                          ₹400 <span>₹599</span>
                        </p>
                      </div>
                    </td>

                    <td>
                      <div className="price_holder">
                        <p>
                          ₹400 <span>₹599</span>
                        </p>
                      </div>
                    </td>

                    <td>
                      <div className="price_holder">
                        <p>
                          ₹400 <span>₹599</span>
                        </p>
                      </div>
                    </td>

                    <td>
                      <div className="Total_holder">
                        <h5>
                          SUBTOTAL <span>₹ 1200</span>
                        </h5>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </Table>
            </div>
          </div> */}
        </div>
      </section>
    </>
  );
}

export default Cart_Products_card;
